import styled, { keyframes } from 'styled-components';

const fold = keyframes`
  0% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  25% {
    transform: scale(0.8) rotate(180deg);
    opacity: 0.5;
  }
  50% {
    transform: scale(1) rotate(360deg);
    opacity: 1;
  }
  100% {
    transform: scale(1) rotate(360deg);
    opacity: 1;
  }
`;

const unfold = keyframes`
  0% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  25% {
    transform: scale(0.8) rotate(180deg);
    opacity: 0.5;
  }
  50% {
    transform: scale(1) rotate(360deg);
    opacity: 1;
  }
  100% {
    transform: scale(1) rotate(360deg);
    opacity: 1;
  }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AnimatedLogo = styled.div`
  width: 100px;
  height: 100px;
  animation: ${fold} 3s ease-in-out infinite;

  svg {
    width: 100%;
    height: 100%;
  }

  path {
    &:nth-child(1),
    &:nth-child(2) {
      animation: ${unfold} 3s ease-in-out infinite;
      animation-delay: 0.5s;
    }
    &:nth-child(3),
    &:nth-child(4) {
      animation: ${fold} 3s ease-in-out infinite;
    }
  }
`;
